import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { MdClose } from "react-icons/md";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import Button from "../../../../Button";
import Header from "../../../../Header";
import Input from "../../../../Input";
import validation from "./validation";

function View({ contact, onSubmit, onClose, locked }) {
  const { t } = useTranslation();
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      ...contact,
      acceptContact: get(contact, "acceptContact") || false,
      acceptDigital: true,
    },
    onSubmit,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  return (
    <>
      <div className="miltis-help-modal__header">
        <Header
          small
          title="Validez vos informations afin qu'un conseiller puisse prendre contact avec vous"
        />
      </div>
      <div className="miltis-form miltis-form--modal">
        <div className="miltis-form__container">
          <div className="miltis-form__row">
            <Input
              placeholder={"ex : 0610203040"}
              label={"N° de téléphone"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                values,
                ...formProps,
              })}
              disabled={locked}
              onChange={({ target: { value } }) => {
                setFieldValue(
                  `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                  value,
                );
                setFieldValue(
                  "showAccept",
                  values.showAccept ||
                    !!(
                      value &&
                      get(
                        values,
                        `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                      )
                    ),
                );
              }}
            />
            <Input
              placeholder={"ex : johndoe@mail.com"}
              label={"Email"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                values,
                ...formProps,
              })}
              disabled={locked}
              onChange={({ target: { value } }) => {
                setFieldValue(
                  `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                  value,
                );
                setFieldValue(
                  "showAccept",
                  values.showAccept ||
                    !!(
                      value &&
                      get(
                        values,
                        `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                      )
                    ),
                );
              }}
            />
          </div>
          <div className="miltis-form__checkbox-wrapper">
            <Input
              type="checkbox"
              label={
                "J'accepte que les données collectées ci-dessus soient utilisées pour la création de mon devis et j'accepte d'être recontacté dans le cadre de cette démarche."
              }
              checked={get(values, "acceptContact") || false}
              onChange={(checked) => {
                setFieldValue("acceptContact", checked);
              }}
              errors={get(formProps.errors, "acceptContact", "")}
              touched={get(formProps.touched, "acceptContact", false)}
              disabled={locked}
            />
          </div>
        </div>
        <div className="miltis__actions miltis__actions--modal">
          <button
            className="miltis__actions--close"
            onClick={onClose}
            type="button"
          >
            <MdClose size={24} />
            <span>Fermer</span>
          </button>
          <div className="miltis__actions--primary">
            <Button
              block
              type={"primary"}
              className="miltis__actions--next"
              disabled={
                !get(values, `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`) ||
                !get(values, `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`) ||
                !get(values, "acceptContact") ||
                !isEmpty(formProps.errors)
              }
              onClick={handleSubmit}
            >
              Valider mes informations
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default View;
